<template>
  <div class="personal-details" @click="disableEditContext">
    <dl class="dict-grid">
      <dt>Full name</dt>
      <dd>
        <toggle-edit :value="fullName" :mayEdit="mayEdit">
          <b-input type="text" v-model="firstName" />
          <b-input type="text" v-model="lastName" />
        </toggle-edit>
        
      </dd>
      <dt>
        <b-icon :icon="passwordLockIcon" @click.native="togglePasswordEdit" title="Edit password" class="edit-password-toggle" />
        <b-icon icon="mail" />
      </dt>
      <dd>
        <toggle-edit :value="email" :mayEdit="mayEdit">
          <b-input type="email" v-model="email" class="email" />
        </toggle-edit>
        
      </dd>
      <dt v-if="editPassword">Password</dt>
      <dd v-if="editPassword" class="password-edit">
        <b-field :error="passwordError" :title="passwordHelp">
          <b-input type="password" v-model="password" class="password" placeholder="Password" />
          <b-input type="password" v-model="cpassword" class="password confirm" placeholder="Confirm password" />
        </b-field>
        <p v-if="passwordError" class="error">{{passwordErrorMsg}}</p>
      </dd>
      <dt>Collective name</dt>
      <dd>
        <toggle-edit :value="collectiveName" :mayEdit="mayEdit">
          <b-input type="text" v-model="collectiveName" class="long-name" />
        </toggle-edit>
      </dd>
      <dt v-if="showEduDetails">Start / end years</dt>
      <dd v-if="showEduDetails">
        <toggle-edit :value="yearRange" :mayEdit="mayEdit">
          <b-input type="number" step="1" v-model="startYearInt" class="year" />
          <b-input type="number" step="1" v-model="endYearInt" class="year" />
        </toggle-edit>
      </dd>
      <dt v-if="showEduDetails">College</dt>
      <dd v-if="showEduDetails">
        <toggle-edit :value="collegeName" :mayEdit="mayEdit">
          <b-autocomplete
            v-model="collegeName"
            placeholder="college name"
            :data="colleges"
            field="label"
            @select="selectCollege"
          ></b-autocomplete>
        </toggle-edit>
      </dd>
      <dt v-if="showEduDetails">Course</dt>
      <dd v-if="showEduDetails">
        <toggle-edit :value="course" :mayEdit="mayEdit">
          <b-input type="text" size="32" v-model="course" class="textfield" />
        </toggle-edit>
      </dd>
      <dt v-if="showEduDetails">Study Status</dt>
      <dd v-if="showEduDetails">
        <toggle-edit :value="graduateStatusText" :mayEdit="mayEdit">
          <b-select placeholder="Select.." v-model="graduateStatus" required>
            <option
              v-for="opt in graduateStatusOptions"
              :value="opt.key"
              :key="opt.key"
            >{{opt.label}}</option>
          </b-select>
        </toggle-edit>
      </dd>
      <dt>
        <b-icon icon="phone" size="is-small" />
      </dt>
      <dd>
        <div v-for="(phone, index) in phones" class="phone" :key="'phone-'+index">
          <toggle-edit :value="phones[index]|displayNumber" :mayEdit="mayEdit">
            <b-input type="text" size="20" v-model="phones[index].identifier" />
            <b-input type="text" step="20" v-model="phones[index].notes" />
          </toggle-edit>
        </div>
      </dd>
      <dt v-if="showBirthDate">Birth date</dt>
      <dd v-if="showBirthDate">
        <toggle-edit :value="birthDate|shortDate" :mayEdit="mayEdit">
          <b-datepicker :first-day-of-week="1" placeholder="DD/MM/YYYY" v-model="birthDate"></b-datepicker>
        </toggle-edit>
      </dd>
    </dl>
    <slot></slot>
    <div v-if="hasStatement" class="statement-section">
       <dl>
        <dt>How will this opportunity benefit your practice?</dt>
        <dd>
          <toggle-edit :value="statement" :mayEdit="mayEdit">
            <b-input type="textarea" v-model="statement" class="statement" rows="3" cols="60" :has-counter="true" />
            </toggle-edit>
        </dd>
       </dl>
    </div>
    <b-button type="is-success" @click="save" class="save" rounded>Save</b-button>
  </div>
</template>
<script type="text/javascript">
import { mapGetters } from "vuex";
import { bus } from "../main";
import filters from "../mixins/filters";
import {
  extractString,
  extractNestedOptions,
  notEmptyString
} from "../api/helpers";
import { saveSubmission, updateUser } from "../api/methods";
import { submissionSchema } from "../store/submission";
import ToggleEdit from "./ToggleEdit";
import { validPassword } from '../api/validators';
import config from '../config/config';

export default {
  name: "PersonalDetails",
  components: {
    ToggleEdit
  },
  props: {
    submission: {
      type: Object,
      required: true,
      default() {
        return submissionSchema;
      }
    }
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      collectiveName: "",
      phones: [],
      birthDate: null,
      startYear: 0,
      endYear: 0,
      startYearInt: 0,
      endYearInt: 0,
      statement: "",
      college: "",
      collegeName: "",
      course: "",
      graduateStatus: "",
      editMode: false,
      editPassword: false,
      password: "",
      cpassword: "",
      passwordErrorMsg: "",
    };
  },
  mixins: [filters],
  mounted() {
    this.mapDetails();
  },
  computed: {
    ...mapGetters(["settings", "user", "colleges", "options"]),
    fullName() {
      return this.firstName + " " + this.lastName;
    },
    yearRange() {
      let years = [];
      if (this.startYearInt > 0) {
        years.push(this.startYearInt.toString());
      }
      if (this.endYearInt > 0) {
        years.push(this.endYearInt.toString());
      }
      return years.join(" - ");
    },
    hasStatement() {
      return this.statement.length > 1;
    },
    mayEdit() {
      return this.user.role === "admin";
    },
    showBirthDate() {
      let vl = false;
      if (this.settings.show_birthdate) {
        vl = this.settings.show_birthdate === true;
      }
      return vl;
    },
    graduateStatusOptions() {
      let opts = extractNestedOptions(
        "submission",
        "graduateStatus",
        this.options
      );
      if (opts.length > 0) {
        opts = opts.map(o => {
          o.label = this.toWords(o.value);
          return o;
        });
      }
      return opts;
    },
    graduateStatusText() {
      let out = "";
      const graduateStatusOpt = this.graduateStatusOptions.find(
        opt => opt.key === this.graduateStatus
      );
      if (graduateStatusOpt) {
        out = graduateStatusOpt.label;
      }
      return out;
    },
    passwordLockIcon() {
      return this.editPassword ? 'lock-open-variant': 'lock';
    },
    passwordError() {
      return notEmptyString(this.passwordErrorMsg, 5);
    },
    passwordHelp() {
      return 'Passwords should be at least 8 characters long and contain at least 1 lower case letter, 1 upper case letter and a numeral. Optionally passwords may also contain one of the following special characters _;:.,-';
    },
    showEduDetails() {
      return config.show
    }
  },
  filters: {
    displayNumber(phone) {
      let str = phone.identifier;
      if (phone.notes) {
        str += " (" + phone.notes + ")";
      }
      return str;
    }
  },
  methods: {
    mapDetails() {
      this.email = extractString(this.submission, "email");

      this.firstName = extractString(this.submission, "firstName");

      this.lastName = extractString(this.submission, "lastName");

      this.collectiveName = extractString(this.submission, "collectiveName");

      this.statement = extractString(this.submission, "statement");

      if (this.submission.phones instanceof Array) {
        this.phones = this.submission.phones
          .filter(p => p instanceof Object)
          .map(p => {
            let item = p;
            if (!p.notes) {
              item.notes = "";
            }
            if (!p.identifier) {
              item.identifier = "";
            }
            return item;
          });
      }

      if (this.submission.birthDate) {
        this.birthDate = this.submission.birthDate;
      }
      if (this.submission.startYear) {
        this.startYear = this.submission.startYear;
      }
      if (this.submission.startYearInt) {
        this.startYearInt = this.submission.startYearInt;
      }
      if (this.submission.endYear) {
        this.endYear = this.submission.endYear;
      }
      if (this.submission.endYearInt) {
        this.endYearInt = this.submission.endYearInt;
      }
      if (this.submission.course) {
        this.course = this.submission.course;
      }
      if (this.submission.graduateStatus) {
        this.graduateStatus = this.submission.graduateStatus;
      }
      if (this.submission.collegeName) {
        this.collegeName = this.submission.collegeName;
      }
      if (this.submission.college) {
        this.college = this.submission.college;
      }
      if (this.submission.statement) {
        this.statement = this.submission.statement;
      }
    },
    selectCollege(c) {
      if (c.id) {
        this.college = c.id;
      }
      if (c.label) {
        this.collegeName = c.label;
      }
    },
    save() {
      if (this.submission.user) {
        if (this.submission.user._id) {
          const edited = {
            _id: this.submission._id,
            user: this.submission.user._id,
            collectiveName: this.collectiveName.trim(),
            statement: this.statement.trim(),
            college: this.college,
            collegeName: this.collegeName.trim(),
            graduateStatus: this.graduateStatus,
            course: this.course.trim(),
            startYear: this.yearYoDateString(this.startYearInt),
            endYear: this.yearYoDateString(this.endYearInt),
            phones: this.phones
          };
          this.disableEdit(500);
          saveSubmission(edited).then(data => {
            if (data.valid) {
              const { uid } = this.submission.user;
              this.toast(`Submission ${uid} updated`);
            }
          });

          bus.$emit("save-details", true);
          const userEdited = {
            firstName: this.firstName,
            lastName: this.lastName,
            identifier: this.email
          };
          this.passwordErrorMsg = '';
          let hasPassword = false;
          if (this.editPassword) {
            if (notEmptyString(this.password, 6)) {
              if (this.password === this.cpassword) {
                if (validPassword(this.password)) {
                  userEdited.password = this.password;
                  this.editPassword = false;
                  hasPassword = true;
                } else {
                  this.passwordErrorMsg = this.passwordHelp.split('.').shift();
                }
              } else {
                this.passwordErrorMsg = 'Passwords do not match';
              }
            }
          }
          if (!this.passwordError) {
            updateUser(this.submission.user._id, userEdited).then(data => {
              if (data.user) {
                const { uid } = data.user;
                const extraSubj = hasPassword? ' and password' : '';
                this.toast(`User ${uid}${extraSubj} updated`);
                this.editPassword = false;
              }
            })
            this.disableEdit(500);
          }
        }
      }
    },
    toast(message = "", duration = 3000) {
      this.$buefy.toast.open({
          duration,
          message,
          position: "is-bottom",
          type: "is-success"
        });
    },
    disableEdit(ts = 10) {
      bus.$emit("person-details-edited", ts);
    },
    disableEditContext(e) {
      if (e instanceof Event) {
        const { target } = e;
        let tn = target.tagName.toLowerCase();
        if (tn === 'span') {
          const parTn = target.parentNode.tagName.toLowerCase();
          if (['dd', 'address','p', 'h5'].includes(parTn)) {
            tn = parTn;
          }
        }
        if (['p', 'div', 'address', 'h5', 'dl', 'dt', 'dd'].includes(tn)) {
          this.disableEdit(50);
        }
      }
    },
    togglePasswordEdit() {
      this.editPassword = !this.editPassword;
    }
  }
};
</script>